
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-cottage",
      function () {
        return require("private-next-pages/all-cottage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-cottage"])
      });
    }
  